// The cookie banner's answer, kept in the tms_consent cookie as v1.a<0|1>.m<0|1>:
// a for analytics (the tms_vid visitor id, util/Traffic.java), m for marketing (unused
// for now, there for ad pixels later). No cookie means not asked yet: nothing but the
// strictly necessary cookies are set until they answer. The server reads the cookie on
// each /startsession and /t call, and withdrawing deletes the visitor's rows.
// Bump VERSION when what the banner asks changes, to ask everyone again.
import { send, track } from './track';

const COOKIE = 'tms_consent';
const VERSION = 'v1';
const MAX_AGE = 395 * 24 * 3600;   // 13 months, then ask again
export const CONSENT_EVENT = 'tms-consent';
export const OPEN_COOKIE_SETTINGS_EVENT = 'tms-cookie-settings';

// {analytics, marketing}, or null when they haven't answered (or answered an older banner)
// Google Analytics (GA4). Its _ga cookies aren't strictly necessary, so the tag is only
// added to the page once they accept analytics, never from public/index.html.
const GA_ID = 'G-ZD7B3E7L7G';
let gaLoaded = false;

const loadGoogleAnalytics = () => {
    window['ga-disable-' + GA_ID] = false;
    if (gaLoaded) return;
    gaLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID);
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
    document.head.appendChild(script);
};

// Declined or withdrawn: stop the tag sending anything and delete the _ga cookies it set,
// on this host and on the domain above it (GA sets them on the widest domain it can)
const stopGoogleAnalytics = () => {
    window['ga-disable-' + GA_ID] = true;
    const names = document.cookie.split(';').map((c) => c.trim().split('=')[0]).filter((n) => /^_ga/.test(n));
    const host = window.location.hostname;
    const domains = ['', host, '.' + host];
    const parts = host.split('.');
    if (parts.length > 2) domains.push('.' + parts.slice(-2).join('.'));
    names.forEach((name) => domains.forEach((d) => {
        document.cookie = `${name}=; Path=/; Max-Age=0${d ? '; Domain=' + d : ''}`;
    }));
};

export const getConsent = () => {
    if (typeof document === 'undefined') return null;
    const m = document.cookie.match(/(?:^|;\s*)tms_consent=([^;]*)/);
    const v = m ? decodeURIComponent(m[1]) : '';
    const p = v.match(/^v(\d+)\.a([01])\.m([01])$/);
    if (!p || 'v' + p[1] !== VERSION) return null;
    return {analytics: p[2] === '1', marketing: p[3] === '1'};
};

export const setConsent = ({analytics, marketing = false}) => {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${COOKIE}=${VERSION}.a${analytics ? 1 : 0}.m${marketing ? 1 : 0}; Path=/; Max-Age=${MAX_AGE}; SameSite=Lax${secure}`;
    if (analytics) loadGoogleAnalytics(); else stopGoogleAnalytics();
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, {detail: {analytics, marketing}}));
    // Sent now, so the server sets or deletes the visitor id straight away
    track('consent', analytics ? 'a1' : 'a0');
    send();
};

// For a "Cookie settings" link in the footer or account menu: shows the banner again
export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));

// Someone who accepted on an earlier visit gets Google Analytics as the app starts
if (typeof window !== 'undefined' && getConsent()?.analytics) loadGoogleAnalytics();
